import fp from 'lodash/fp'

interface User {
  firstNames?: string | null
  lastName?: string | null
}

export const displayNameOf = ({ firstNames, lastName }: User): string =>
  [firstNames, lastName].filter((name) => !!name).join(' ')

export const reversedDisplayNameOf = ({ firstNames, lastName }: User): string =>
  [lastName, firstNames].filter((name) => !!name).join(', ')

export const hasName = ({ firstNames, lastName }: User): boolean =>
  !fp.isEmpty(firstNames) && !fp.isEmpty(lastName)
